import validators from '../../../../utilities/validators';

const validator = validators.compose(
    validators.requiredNonEmptyString('displayName'),
    validators.requiredNumber('amount'),
    validators.requiredString('currency'),
    validators.requiredString('merchantAccount'),
    validators.requiredString('apiKey'),
    validators.requiredString('clientKey'),
    validators.requiredString('environment'),
    validators.forEach('hmacKeys', validators.requiredString('')),
    validators.requiredString('username'),
    validators.requiredString('password')
);

export default validator;
